<template>
  <div>
    <TextInputConfiguration
      :controller="OrderStringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <TextInputConfiguration
      :controller="F1StringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
    <TextInputConfiguration
      :controller="F2StringCtrller"
      :sizeinput="'sm'"
      :forcerow="true"
    />
  </div>
</template>

<script>
import {inputTextConfCtrller} from '@/assets/classes/configuration.js'
import { ConfigName } from '@/common/sharedDefinitions/commonPlotDefinitions'
import TextInputConfiguration from '@/components/properties/elements/TextInputConfiguration'

export default {
  name: 'BSF',
  components:{
    TextInputConfiguration,
  },
  props: {
    sectionconfig:{
      type:String,
      required:true
    }
  },
  data() {
    return {
      elementsConfig:[],
      OrderStringCtrller: new inputTextConfCtrller(ConfigName.OrderBSFPreProc,'Order','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0}),
      F1StringCtrller: new inputTextConfCtrller(ConfigName.F1BSFPreProc,'f1','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0}),
      F2StringCtrller: new inputTextConfCtrller(ConfigName.F2BSFPreProc,'f2','Please give a numerical value greater than zero','1',(value)=>{return !isNaN(value)&& value>0}),
    }
  },
  mounted(){
    this.elementsConfig = [
      this.OrderStringCtrller,
      this.F1StringCtrller,
      this.F2StringCtrller
    ]
    this.elementsConfig.forEach(conf=>conf.configCategory=this.sectionconfig)
    this.elementsConfig.forEach(conf=>conf.setParent(this))
  },
}
</script>

<style>
